var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { PlanType, PlanTypeCategory, StatusPermission } from '../../../enum';
import { BasePanel } from '../common/basePanel';
import { QueuePanel } from '../common/queuePanel';
import { StepContainer, StepPanel } from '../common/stepContainer';
import { WizardContext } from '../context';
import { useRefreshQueueData } from '../queue/selectors';
import { QueueStatusType } from '../queue/types';
import { useEffectiveCapacityPermission, useIsPlanLocked, usePlanType, usePlanTypeCategory } from '../selectors';
import { AddRoleForm } from './addRoleForm';
import { CalculatorDialog } from './calculatorDialog';
import { SupportStaffTable } from './locationRoleTable';
import { useClearRoleAPI, useCopyRoleAPI } from './selectors';
export var SupportStaffStep = function () {
  var t = useTranslation('wizard', {
    keyPrefix: 'supportStaff'
  }).t;
  var _a = useState(false),
    open = _a[0],
    setOpen = _a[1];
  var refreshData = useRefreshQueueData();
  var _b = useCopyRoleAPI(),
    copyRoleData = _b[0],
    copyRole = _b[1],
    clearCopyRoleData = _b[2];
  var _c = useClearRoleAPI(),
    clearRoleData = _c[0],
    clearRole = _c[1],
    cleanClearRoleData = _c[2];
  var _d = useFormContext(),
    watch = _d.watch,
    setValue = _d.setValue;
  var planType = usePlanType();
  var planTypeCategory = usePlanTypeCategory();
  var handleSave = useContext(WizardContext).handleSave;
  var isDirty = useFormContext().formState.isDirty;
  var capacityPermission = useEffectiveCapacityPermission();
  var isPlanLocked = useIsPlanLocked();
  var isDisabled = capacityPermission !== StatusPermission.Edit || isPlanLocked;
  var handleClear = function () {
    if (isDirty && handleSave) {
      return handleSave('submit', function () {
        return clearRole();
      })();
    }
    clearRole();
  };
  var handleCopy = function (source) {
    if (isDirty && handleSave) {
      return handleSave('submit', function () {
        return copyRole(source);
      })();
    }
    copyRole(source);
  };
  useEffect(function () {
    if (clearRoleData.data || copyRoleData.data) {
      refreshData();
    }
    return function () {
      cleanClearRoleData();
      clearCopyRoleData();
    };
  }, [cleanClearRoleData, clearCopyRoleData, refreshData, clearRoleData.data, copyRoleData.data]);
  var calculatorButtonText = planTypeCategory === PlanTypeCategory.ProdHours ? 'trainerRatioCalculator' : 'trainerAndQaRatioCalculator';
  return _jsx(StepContainer, __assign({
    leftContent: _jsx(QueuePanel, {})
  }, {
    children: _jsxs(StepPanel, {
      children: [_jsx(BasePanel, __assign({
        title: t('title'),
        statusType: QueueStatusType.SupportStaff,
        onClear: handleClear,
        onCopy: handleCopy,
        errors: [clearRoleData.error, copyRoleData.error],
        requesting: !!clearRoleData.requesting || !!copyRoleData.requesting,
        leftContent: _jsx(Button, __assign({
          variant: "outlined",
          onClick: function () {
            return setOpen(true);
          },
          disabled: isDisabled || planType !== PlanType.Monthly
        }, {
          children: t(calculatorButtonText)
        }))
      }, {
        children: _jsx(SupportStaffTable, {
          disableFinancial: true
        })
      })), _jsx(AddRoleForm, {}), _jsx(CalculatorDialog, {
        open: open,
        onClose: function () {
          return setOpen(false);
        },
        setValue: setValue,
        watch: watch
      })]
    })
  }));
};